import ConfettiComponent from "@/components/confetti";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { Button } from "@/components/ui/button";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useState } from "react";

export const SetupTrialEndedBillingFinishPage = () => {
  const { t } = useTranslation();
  const api = useApi();

  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const closeTrialBilling = async () => {
    try {
      setIsLoading(true);
      await api.post(`/my/team/setup/finish-trial`);
      setIsSuccess(true);
    } catch (error) {
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    closeTrialBilling();
  }, []);

  const reload = () => {
    window.location.reload();
  };
  const redirectToHome = () => {
    window.location.href = "/";
  };

  if (isLoading) {
    return <div>{t("setup.trialEndedBilling.finish.loading")}</div>;
  }

  if (!isSuccess) {
    return (
      <div className="space-y-5 text-center">
        <h1 className="text-2xl font-bold text-primary">
          {t("setup.trialEndedBilling.finish.error.title")}
        </h1>
        <p>{t("setup.trialEndedBilling.finish.error.description")}</p>
        <SupportMessage />
        <Button onClick={reload}>
          {t("setup.trialEndedBilling.finish.buttons.retry")}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.trialEndedBilling.finish.success.title")}
      </h1>
      <p className="text-md">
        {t("setup.trialEndedBilling.finish.success.description")}
      </p>
      <Button onClick={redirectToHome}>
        {t("setup.trialEndedBilling.finish.buttons.home")}
      </Button>
      <ConfettiComponent />
    </div>
  );
};
